import { render } from "./BreadcrumbOi.vue?vue&type=template&id=7f597fd6&scoped=true"
import script from "./BreadcrumbOi.vue?vue&type=script&lang=js"
export * from "./BreadcrumbOi.vue?vue&type=script&lang=js"

import "./BreadcrumbOi.vue?vue&type=style&index=0&id=7f597fd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f597fd6"]])

export default __exports__